export function initA11y(){

  const body = document.body;

  // -----------------------------
  // ELEMENTOS
  // -----------------------------

  const btnIncrease = document.querySelector('[data-a11y="increase"]');
  const btnDecrease = document.querySelector('[data-a11y="decrease"]');
  const btnContrast = document.querySelector('[data-a11y="contrast"]');

  const langToggle = document.querySelector('[data-a11y="lang"]');
  const langWrap   = document.querySelector('.a11y__tool--lang');
  const langOptions = document.querySelectorAll('.a11y__option');

  const langLabel = langToggle?.querySelector('.a11y__text');

  const MAX_FONT = 3;
  const MIN_FONT = 0;

  let fontLevel = parseInt(localStorage.getItem('a11y-font')) || 0;
  let contrast  = localStorage.getItem('a11y-contrast') === 'true';
  let currentLang = localStorage.getItem('site-lang') || 'ES';

  let translateLoaded = false;

  // -----------------------------
  // FONT SIZE
  // -----------------------------

  function updateFont(){

    body.classList.remove(
      'a11y-font-1',
      'a11y-font-2',
      'a11y-font-3'
    );

    if(fontLevel > 0){
      body.classList.add(`a11y-font-${fontLevel}`);
    }

    localStorage.setItem('a11y-font', fontLevel);

    btnDecrease?.classList.toggle('_disabled', fontLevel === MIN_FONT);
    btnIncrease?.classList.toggle('_disabled', fontLevel === MAX_FONT);

  }

  btnIncrease?.addEventListener('click', () => {

    if(fontLevel >= MAX_FONT) return;

    fontLevel++;
    updateFont();

  });

  btnDecrease?.addEventListener('click', () => {

    if(fontLevel <= MIN_FONT) return;

    fontLevel--;
    updateFont();

  });

  // -----------------------------
  // CONTRASTE
  // -----------------------------

  function updateContrast(){

    body.classList.toggle('a11y-contrast', contrast);
    btnContrast?.classList.toggle('_active', contrast);
    btnContrast?.setAttribute('aria-pressed', contrast ? 'true' : 'false');

    localStorage.setItem('a11y-contrast', contrast);

  }

  btnContrast?.addEventListener('click', () => {

    contrast = !contrast;
    updateContrast();

  });

  // -----------------------------
  // GOOGLE TRANSLATE
  // -----------------------------

  function loadTranslate(callback){

    if(translateLoaded){
      callback();
      return;
    }

    translateLoaded = true;

    window.googleTranslateElementInit = function(){

      new google.translate.TranslateElement({
        pageLanguage:'es',
        includedLanguages:'en',
        autoDisplay:false
      }, 'google_translate_element');

      waitForSelect(callback);

    };

    const script = document.createElement('script');
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;

    document.body.appendChild(script);

  }

  function waitForSelect(callback){

    const interval = setInterval(() => {

      const select = document.querySelector('.goog-te-combo');

      if(select){
        clearInterval(interval);
        callback();
      }

    },100);

  }

  function setLang(lang){

    if(lang === 'ES'){

      localStorage.setItem('site-lang','ES');
      location.reload();
      return;

    }

    const select = document.querySelector('.goog-te-combo');

    if(!select) return;

    select.value = 'en';
    select.dispatchEvent(new Event('change'));

    currentLang = 'EN';

    updateLangUI('EN');

    localStorage.setItem('site-lang','EN');

  }

  // -----------------------------
  // LANG UI
  // -----------------------------

  function updateLangUI(lang){

    langOptions.forEach(o => o.classList.remove('_active'));

    const active = document.querySelector(`[data-a11y-lang="${lang}"]`);

    active?.classList.add('_active');

    if(langLabel){
      langLabel.textContent = lang;
    }

  }

  langToggle?.addEventListener('click', () => {

    const open = langWrap.classList.toggle('_open');
    langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');

  });

  langOptions.forEach(option => {

    option.addEventListener('click', () => {

      const lang = option.dataset.a11yLang;

      langWrap.classList.remove('_open');
      langToggle?.setAttribute('aria-expanded', 'false');

      if(lang === 'EN'){

        loadTranslate(() => setLang('EN'));

      }else{

        setLang('ES');

      }

    });

  });

  document.addEventListener('click', e => {

    if(!langWrap?.contains(e.target)){
      langWrap?.classList.remove('_open');
      langToggle?.setAttribute('aria-expanded', 'false');
    }

  });

  // -----------------------------
  // RESTORE STATE
  // -----------------------------

  updateLangUI(currentLang);

  if(currentLang === 'EN'){
    loadTranslate(() => setLang('EN'));
  }

  // -----------------------------
  // INIT
  // -----------------------------

  updateFont();
  updateContrast();

}